import React from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const FlowStartRule = ({ fid, rule = {}, tasks = [], otherFlows = [], onChange }) => {
  const mode = rule.mode || "immediate";
  const keys = rule.task_keys || [];
  const named = tasks.filter((t) => (t.title || "").trim());
  const toggle = (k) => onChange({ ...rule, task_keys: keys.includes(k) ? keys.filter((x) => x !== k) : [...keys, k] });
  const wf = rule.wait_flow_ids || [];
  const toggleFlow = (k) => onChange({ ...rule, wait_flow_ids: wf.includes(k) ? wf.filter((x) => x !== k) : [...wf, k] });
  const chip = (on) => `rounded-full border px-2.5 py-1 text-[11px] transition-colors ${on ? "bg-[#06060C] text-white border-[#06060C]" : "bg-white text-[#595D62] border-[#EEEFEF] hover:border-[#c4c5cc]"}`;
  return (
    <div className="pl-7 pr-1 pb-1 space-y-2" data-testid={`catalogue-flow-rule-${fid}`}>
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-[11px] text-[#9FA1A4]">Start</span>
        <Select value={mode} onValueChange={(v) => onChange({ ...rule, mode: v })}>
          <SelectTrigger data-testid={`catalogue-flow-mode-${fid}`} className="h-8 w-52 bg-white border-[#EEEFEF] text-xs"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white border-[#EEEFEF]">
            <SelectItem value="immediate">Immediately</SelectItem>
            <SelectItem value="date">On a start date</SelectItem>
            <SelectItem value="tasks">When chosen tasks are done</SelectItem>
            <SelectItem value="flow">When another flow is done</SelectItem>
          </SelectContent>
        </Select>
        {mode === "date" && <>
          <Input data-testid={`catalogue-flow-offset-${fid}`} type="number" min={0} value={rule.offset_days ?? 0} onChange={(e) => onChange({ ...rule, offset_days: e.target.value === "" ? 0 : Math.max(0, Number(e.target.value)) })} className="h-8 w-20 bg-white border-[#EEEFEF] text-xs text-center" />
          <span className="text-[11px] text-[#9FA1A4]">days after project start</span>
        </>}
      </div>
      {mode === "tasks" && (named.length === 0 ? <p className="text-[11px] text-amber-700">Add tasks above first, then tick the ones this flow waits for.</p> : (
        <div className="flex flex-wrap gap-1.5">
          {named.map((t) => (
            <button type="button" key={t.key} data-testid={`catalogue-flow-wait-${fid}-${t.key}`} onClick={() => toggle(t.key)}
              className={`rounded-full border px-2.5 py-1 text-[11px] transition-colors ${keys.includes(t.key) ? "bg-[#06060C] text-white border-[#06060C]" : "bg-white text-[#595D62] border-[#EEEFEF] hover:border-[#c4c5cc]"}`}>{t.title}</button>
          ))}
        </div>
      ))}
      {mode === "tasks" && named.length > 0 && keys.length === 0 && <p className="text-[11px] text-amber-700">Pick at least one task, otherwise the flow starts immediately.</p>}
      {mode === "flow" && (otherFlows.length === 0 ? <p className="text-[11px] text-amber-700">Tick another flow on this item first.</p> : (
        <div className="flex flex-wrap gap-1.5">
          {otherFlows.map((f) => <button type="button" key={f.id} data-testid={`catalogue-flow-waitflow-${fid}-${f.id}`} onClick={() => toggleFlow(f.id)} className={chip(wf.includes(f.id))}>{f.name}</button>)}
        </div>
      ))}
      {mode === "flow" && otherFlows.length > 0 && wf.length === 0 && <p className="text-[11px] text-amber-700">Pick a flow, otherwise this one starts immediately.</p>}
      {mode === "flow" && <p className="text-[11px] text-[#595D62]">Starts once every task and subtask in the chosen flow is completed.</p>}
      {mode !== "immediate" && <p className="text-[11px] text-[#595D62]">Due dates in this flow count from the day it starts.</p>}
    </div>
  );
};
